import { render, staticRenderFns } from "./user-agreement-section.vue?vue&type=template&id=34a04935&scoped=true&lang=pug&"
import script from "./user-agreement-section.vue?vue&type=script&lang=ts&"
export * from "./user-agreement-section.vue?vue&type=script&lang=ts&"
import style0 from "./user-agreement-section.vue?vue&type=style&index=0&id=34a04935&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a04935",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
